import React from "react";
import "./CommunityScreen.css";
import BracketList from "components/reusable/BracketList";
import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import FollowScreenCard from "components/reusable/FollowScreenCard";


class PersonalScreen extends React.Component {

  constructor(props){
    super(props);

    const cookieManager = new CookieManager();
    this.accountId = cookieManager.getValue(Constants.COOKIE_USER_ID);
    this.state = {
        isLoading: true,
        emptyListMessage: 'You haven\'t published any brackets yet'   
    };

  }

  
  componentDidMount(){
  }

  //TODO: display a button to launch any current drafts
  render(){
 
    return (
        <>
                
            <FollowScreenCard onSettingsClick={this.props.onSettingsClick}></FollowScreenCard>

            
            <div className="brackset-list-header">
                <div className="brackset-list-header-text">
                    Brackets
                </div>
            </div>
            <div className="personal-nav-launcher nav-panel">
                <BracketList createdBy={this.accountId} variant="feed" emptyMessage={this.state.emptyListMessage}></BracketList>
            </div>       
        </>
    );
  }
}

export default PersonalScreen;
